module.exports = __webpack_public_path__ + "static/media/summerBlue.3245bd72.jpg";